// The `evidence/guidance` api module — the two HealthPathways zone transports,
// carved out of the `src/api/scribeAPIV2.ts` endpoint hub (which now re-exports
// both name-intact).
//
// A PARTIAL EXTRACTION FROM THE HUB, so `git log --follow` will not trace this
// path — history: `git log --follow src/api/scribeAPIV2.ts`.
//
// THIS IS THE FIRST HUB CARVE ON THIS LANE. The two sibling families carved
// standalone api MODULES (`src/lib/api/{transcript-chips,evidence-leaderboard}.ts`)
// or were born from inline `queryFn` bodies; these two fns are the child
// change's D1.2, the only evidence endpoints living in the shared hub, and the
// difference shows in ONE decision below.
//
// S1, the transport severance: `@/utils/scribeHTTP`'s `scribeHttpV2` module
// singleton becomes `getScribeHttpClients().scribeHttpV2` from the
// `@heidi/api/client` registry. Same instance, same interceptors, same
// auth/refresh state — so path, verb, body and response shape are unchanged.
//
// THE AXIOS RESPONSE IS NOT UNWRAPPED, and that is the decision the hub origin
// forces. Every other api module in this package returns `data`; these two
// return the response envelope, because the hub's contract IS the envelope —
// both call sites destructure `const { data } = await …`, and the hub keeps
// re-exporting these names, so unwrapping here would silently change the shape
// a hub caller gets while type-checking fine at the two sites that move with
// it. Consistency with the sibling modules is worth less than a re-export that
// means what it meant.
//
// The client is resolved PER CALL rather than destructured at module scope, for
// the reason the sibling modules record: the registry is populated by
// `src/utils/scribeHTTP.ts` at factory time, and a module-scope read resolves at
// import time — before bootstrap, for any chunk a bundler evaluates early.
//
// NO NAMESPACE OBJECT. `transcript-chips.ts` and `evidence-leaderboard.ts` both
// export one because app suites mock them by name; the suites that intercept
// these two mock the HUB path (`@/pages/api/scribeAPIV2`), which is unchanged,
// so a namespace object here would be package surface with no consumer.
import { getScribeHttpClients } from '@heidi/api/client';

import type {
  HealthPathwaysSetupRequest,
  HealthPathwaysSetupResponse,
} from '../../contracts';

interface ScribeHttp {
  post<T>(url: string, body?: unknown): Promise<{ data: T }>;
  delete<T>(url: string): Promise<{ data: T }>;
}

/** `scribeHttpV2` base is /api/v2/ml-scribe/; scribe JWT injected by interceptor. */
const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;

/** `POST /evidence/healthpathways/setup` — set or replace the clinician's zone. */
export const setupHealthPathwaysZone = (body: HealthPathwaysSetupRequest) => {
  return http().post<HealthPathwaysSetupResponse>('/evidence/healthpathways/setup', body);
};

/** `DELETE /evidence/healthpathways/setup` — clear the clinician's zone. */
export const removeHealthPathwaysZone = () => {
  return http().delete<{ success: boolean }>('/evidence/healthpathways/setup');
};
